/* eslint-disable no-extra-boolean-cast */
/* eslint-disable max-len */
// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import CompetitionsInternationalesSingleMatchToCome from 'components/competitionsInternationales/CompetitionsInternationalesSingleMatchToCome';
import CompetitionsInternationalesSingleMatchLive from 'components/competitionsInternationales/CompetitionsInternationalesSingleMatchLive';
import CompetitionsInternationalesSingleMatchOver from 'components/competitionsInternationales/CompetitionsInternationalesSingleMatchOver';
import Loading from 'components/fragments/Loading';
import { STATUS_LOADING } from 'constants/statusConstants';
import type { Status } from 'types/Status';
import type { RencontreType } from 'types/Rencontre';
import type { RouterProps } from 'types/Router';

import './CompetitionsInternationalesSingleMatch.css';

export type DispatchProps = {
  fetchRencontre: (slug: string) => void
};

export type StateProps = {
  rencontre: RencontreType,
  status: Status
};

type Props = DispatchProps & RouterProps & StateProps;

class CompetitionsInternationalesSingleMatch extends Component<Props> {
  componentDidMount() {
    const {
      fetchRencontre,
      match: {
        params: { matchSlug }
      }
    } = this.props;

    if (!!matchSlug) {
      fetchRencontre(matchSlug);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      fetchRencontre,
      match: {
        params: { matchSlug }
      }
    } = this.props;

    if (prevProps.match.params.matchSlug !== matchSlug && !!matchSlug) {
      fetchRencontre(matchSlug);
    }
  }

  render() {
    const {
      rencontre,
      rencontre: {
        competition,
        meta: { rencontre_live, rencontre_terminee }
      },
      status
    } = this.props;

    if (status === STATUS_LOADING) {
      return (
        <section className="single-match">
          <Loading isWhite />
        </section>
      );
    }

    return (
      <section className="container single-match">
        {!rencontre_live && !rencontre_terminee && (
          <CompetitionsInternationalesSingleMatchToCome
            rencontre={rencontre}
            competition={competition}
            status={status}
          />
        )}
        {!!rencontre_live && !rencontre_terminee && (
          <CompetitionsInternationalesSingleMatchLive rencontre={rencontre} competition={competition} status={status} />
        )}
        {!!rencontre_terminee && (
          <CompetitionsInternationalesSingleMatchOver rencontre={rencontre} competition={competition} status={status} />
        )}
      </section>
    );
  }
}

export default withRouter(CompetitionsInternationalesSingleMatch);
